import { Profile } from "../../../../api/api-profile";
import * as types from "../constants/action-types";

export function updateProfile(accessToken, profileBody, useOldEndpoint) {
  return (dispatch, getState) => {
    const { profile } = getState();

    // If the user is a FA user, we need to use the new endpoint to update the profile
    const useNewEndpoint = useOldEndpoint
      ? false
      : !!profile?.data?.ext_user_id;

    return new Promise((resolve, reject) => {
      const handleResponse = (response) => {
        if (response.error) {
          dispatch({ type: types.PROFILE_UPDATE_FAILURE });
        } else {
          dispatch({
            type: types.PROFILE_UPDATE_SUCCESS,
            profile: response.profile,
          });
        }
        return response.error ? reject(response.error) : resolve(response);
      };

      if (useNewEndpoint) {
        Profile.updateNew(accessToken, profileBody, handleResponse);
      } else {
        Profile.update("me", accessToken, profileBody, handleResponse);
      }
    });
  };
}

export function verifyPhone(verificationCode, verificationId) {
  return (dispatch, getState) => {
    const { auth, profile } = getState();

    const accessToken = auth.accessToken;

    // If the user is a FA user, we need to use the new endpoint to update the profile
    const useNewEndpoint = !!profile?.data?.ext_user_id;

    const payload = useNewEndpoint
      ? { code: verificationCode, verification_id: verificationId }
      : { phone_verification_code: verificationCode };

    return new Promise((resolve, reject) => {
      const handleResponse = (response) => {
        if (response.error) {
          dispatch({ type: types.PROFILE_UPDATE_FAILURE });
        } else {
          dispatch({
            type: types.PROFILE_UPDATE_SUCCESS,
            profile: response.profile,
          });
        }
        return response.error ? reject(response.error) : resolve(response);
      };

      if (useNewEndpoint) {
        Profile.submitPhoneVerifyCode(accessToken, payload, handleResponse);
      } else {
        Profile.submitPhoneVerifyCodeOld(accessToken, payload, handleResponse);
      }
    });
  };
}
